import { TrackingReferral } from '@anytag/shared-organisms';
import { useEngagementDetailsContext } from '../engagement-details-context';

export const EngagementTrackingReferral = () => {
  const { engagement } = useEngagementDetailsContext();

  return <TrackingReferral campaign={{ id: engagement.id, title: engagement.title, type: 'engagement' }} />;
};
